import moment from 'moment'
import numeral from 'numeral'

export default {
  methods: {
    dateFormatter (value) {
      return moment(value).format('Y-MM-DD')
    },

    dateShortFormatter (value) {
      if (value) {
        return moment(value).format('MMM DD, YYYY')
      }
      return null
    },

    dateTimeLongFormatter (value) {
      if (value) {
        return moment(value).format('MMMM DD, YYYY @ LT')
      }
      return null
    },

    dateTimeFormatter (value) {
      return moment(value).format('Y-MM-DD H:mm:ss')
    },

    numberFormatter (value) {
      return numeral(value).format('0,0.00')
    },

    numberFormatterNoDecimal (value) {
      return numeral(value).format('0,0')
    },

    objectToUrl (payload, includeNoValues = true) {
      const payloadKeys = Object.keys(payload)

      if (payloadKeys.length <= 0) {
        return ''
      }

      return payloadKeys.map(
        payloadKey => {
          if (typeof payload[payloadKey] === 'undefined' || payload[payloadKey] === 'null' || payload[payloadKey] === null) {
            return includeNoValues ? `${payloadKey}=` : null
          }

          if (Array.isArray(payload[payloadKey]) > 0) {
            return this.arrayToUrlLists(
              Array.from(payload[payloadKey]),
              payloadKey
            )
          }

          return `${payloadKey}=${payload[payloadKey]}`
        }
      ).filter(value => value).join('&').toString()
    },

    arrayToUrlLists (values, payloadKey = 'lists') {
      if (Array.isArray(values) <= 0) {
        return ''
      }

      return values.filter(value => value).map(
        value => `${payloadKey}[]=${value}`
      ).join('&').toString()
    }
  }
}
